export const DEFAULT_COOKIE_AGE_ONE_YEAR = 60 * 60 * 24 * 365;
export const DEFAULT_COOKIE_SETTING = { maxAge: DEFAULT_COOKIE_AGE_ONE_YEAR, path: '/' };
